import React from "react";
import TechNavbar from "../components/TechNavbar";
import ISP_HeroSection from "../components/ISP/ISP_HeroSection";
import Footer from "../components/Footer";
import WhyChooseUsSection from "../components/ISP/WhyChooseUs";
import Pricing from "../components/ISP/Pricing";
import CoverageAndSupportSection from "../components/ISP/CoverageAndSupport";
import FadeInSection from "../components/FadeInSection";
import TestimonialsSection from "../components/Testimonial";

const IspPage = () => {
  return (
    <div className="min-h-screen">
      <TechNavbar />

      <FadeInSection>
        <ISP_HeroSection />
      </FadeInSection>

      <FadeInSection>
        <WhyChooseUsSection />
      </FadeInSection>

      <FadeInSection>
        <Pricing />
      </FadeInSection>

      <FadeInSection>
        <CoverageAndSupportSection />
      </FadeInSection>

      <FadeInSection>
        <TestimonialsSection />
      </FadeInSection>

      <Footer />
    </div>
  );
};

export default IspPage;
